import * as React from "react";
function SvgDouyin(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <rect fill="#5ab8b5" height={32} rx={6} width={32} />
      <path
        d="M21.1 12.15A10.41 10.41 0 0027 14V9.49a5.89 5.89 0 01-5.9-5.88V3.5h-4.52v17a3.54 3.54 0 11-3.53-3.5v-4.52a8 8 0 100 16c4.05 0 7.67-3 8-6.89.17-2.36.08-9.46.08-9.46"
        fill="#fff"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDouyin);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
